$(document).ready(function() {
  if ($(window).width() < 768) {
    $('footer .menu').each(function(index, el) {
      var items = $(el).find('li').length;
      if (items == 1) {
        $(el).find('li').addClass('no-icon');
      }
    });
    $('footer .menu:not(.social) li:first-child').on('click', function() {
      $(this).parent().toggleClass('expanded');
      if ( $(this).siblings('li:not(:first-child)').is(':visible') ) {
        $(this).siblings('li:not(:first-child)').slideUp();
      } else {
        $(this).siblings('li:not(:first-child)').slideDown();
      }
    });
  }
});
